import api from './api'

export const formService = {
  listForms() {
    return api.get('/admin/forms')
  },
  getForm(id) {
    return api.get(`/admin/forms/${id}`)
  },
  createForm(payload) {
    return api.post('/admin/forms', payload)
  },
  updateForm(id, payload) {
    return api.put(`/admin/forms/${id}`, payload)
  },
  deleteForm(id) {
    return api.delete(`/admin/forms/${id}`)
  },
  saveFields(id, fields) {
    return api.put(`/admin/forms/${id}/fields`, fields)
  },
  listSubmissions(id, params) {
    return api.get(`/admin/forms/${id}/submissions`, { params })
  },
  exportSubmissions(id, params) {
    return api.get(`/admin/forms/${id}/submissions/export`, {
      params,
      responseType: 'blob'
    })
  },
  shareUrl(code) {
    const origin = window.location.origin
    return `${origin}/form/f/${encodeURIComponent(code)}`
  }
}
